import * as t from 'io-ts';

import {RContactsManagerSearchTab} from '../parameters/contactsManagerParameters';
import {
  RContactsManagerAccountsTableState,
  RContactsManagerContactsTableState,
  RContactsManagerSearchCardGroupsTableState,
} from '../table/contactsManagerTableState';

/*
 * Runtime types.
 */

export const RContactsManagerSearchState = t.intersection([
  t.type({
    selectedTab: RContactsManagerSearchTab,
  }),
  t.partial({
    contactsTableState: RContactsManagerContactsTableState,
    accountsTableState: RContactsManagerAccountsTableState,
    cardGroupsTableState: RContactsManagerSearchCardGroupsTableState,
  }),
]);

/*
 * Types.
 */

export interface ContactsManagerSearchState extends Readonly<t.TypeOf<typeof RContactsManagerSearchState>> {}
